import { isEqual } from 'lodash-es';
import { Observable, of, throwError } from 'rxjs';
import { switchMap } from 'rxjs/operators';

import { CustomErrorType, RecordSecurityGroups, SecurityGroup, waitForIndex } from '@digihaven/shared';

import { SeriesService } from '@common/services/series/series.service';

export const WaitForSecurityGroupsUpdate = (
    seriesId: string,
    seriesVersion: string,
    currentSecurityGroups: SecurityGroup[],
    service: SeriesService
): Observable<RecordSecurityGroups> => {
    return service.getSecurityGroups(seriesId, Number(seriesVersion)).pipe(
        switchMap(result => {
            const securityGroupsIdsInIndex = result.SecurityGroups.filter(
                securityGroup => !securityGroup.IsReadOnly
            ).map(securityGroup => securityGroup.Id);
            const currentSecurityGroupIds = currentSecurityGroups
                .filter(securityGroup => !securityGroup.IsReadOnly)
                .map(securityGroup => securityGroup.Id);

            if (isEqual(securityGroupsIdsInIndex, currentSecurityGroupIds)) {
                return throwError(CustomErrorType.SaveIndexTimeout);
            } else {
                return of(result);
            }
        }),
        waitForIndex()
    );
};
